<template>
  <div
    ref="zetaReviewSummary"
    :data-site-id="zetaSiteId"
    :data-questionnaire-slug="zetaQuestionnaireSlug"
    :data-item-id="product.zetaItemId"
    :data-item-unit="product.zetaItemUnit"
  ></div>
</template>

<script>
import Product from '~/js/models/product'
import OSProduct from '~/js/models/OSProduct'
import { ID_DATA } from '~/js/constants/data-element-ids'
const elementData = document.getElementById(ID_DATA)
const { zetaSiteId, zetaQuestionnaireSlug } = elementData?.dataset || {}

export default {
  name: 'ComponentsReviewSummary',
  props: {
    product: {
      type: [Product, OSProduct],
      required: true,
      default: () => {
        return new Product()
      },
    },
  },
  data() {
    return {
      zetaSiteId,
      zetaQuestionnaireSlug,
    }
  },
  mounted() {
    window.zvRenderReviewSummary(this.$el)
    this.$el.classList.add('zv-summary')
  },
}
</script>
